// Versionsnummer der App (Jahr.Monat.Tag.Build, der Build zählt fortlaufend) und die Versionshinweise – beides setzt vite.config.ts beim Build ein.
declare const __APP_VERSION__: string;
declare const __APP_VERSIONEN__: Versionshinweis[];

export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'Entwicklung';

/** Eine Änderung mit der Version, in der sie ausgerollt wurde (automatisch aus dem Git-Verlauf, neueste zuerst). */
export interface Versionshinweis { version: string; datum: string; titel: string; text: string }

export const VERSIONSHINWEISE: Versionshinweis[] = typeof __APP_VERSIONEN__ === 'object' ? __APP_VERSIONEN__ : [];

export const datumText = (iso: string) => iso.split('-').reverse().join('.');

/** Filter: jedes Wort des Suchtexts muss in Version, Datum (auch TT.MM.JJJJ), Überschrift oder Text vorkommen; dazu optional genau eine Version. */
export function hinweiseFiltern(liste: Versionshinweis[], suche: string, version = ''): Versionshinweis[] {
  const worte = suche.toLowerCase().split(/\s+/).filter(Boolean);
  return liste.filter((h) => {
    if (version && h.version !== version) return false;
    const alles = `${h.version} ${h.datum} ${datumText(h.datum)} ${h.titel} ${h.text}`.toLowerCase();
    return worte.every((w) => alles.includes(w));
  });
}
